import { AnyAction } from "redux"
import { ThunkAction } from "redux-thunk"
import { requestThunk } from "swiipe.portal.shared"
import { endpoints } from "./../../data/endpoints"
import { StoreState } from "./../StoreState"
import { userRelationSelectors } from "./../reducers/userRelationReducer"
import { IShopifyAppUrls, shopifyActions, shopifySelectors } from "../reducers/shopifySlice"

export const ensureShopifyAppUrlsThunks =
    (swMerchantId: string, force: boolean): ThunkAction<void, StoreState, null, AnyAction> =>
    async (dispatch, getState) => {
        const currentUserRelation = userRelationSelectors.currentUserRelation(getState())
        if (!currentUserRelation || currentUserRelation.relationType !== "Merchant") {
            return
        }

        if (!force && shopifySelectors.appUrls(getState(), swMerchantId)) {
            return
        }

        const resp = await dispatch(
            requestThunk<{
                webshops: {
                    webshopId: string
                    apps: IShopifyAppUrls[]
                }[]
            }>(endpoints.Shopify.appUrls, {
                params: {
                    swMerchantId: currentUserRelation.id,
                },
            })
        )

        dispatch(
            shopifyActions.setAppUrls({
                swMerchantId: currentUserRelation.id,
                appUrls: Object.fromEntries(resp.webshops.map((w) => [w.webshopId, w.apps])),
            })
        )
    }
